import {ofType} from 'redux-observable';
import {delay, mergeMap, retryWhen, switchMap, filter} from 'rxjs/operators';
import {defer} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {fetchChildPlansObservable} from 'web-app/react/profile/child-profile/plans-and-invoices/epics';
import PlansEntity from 'web-app/react/entities/plans/index';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import * as Actions from './actions';

const NoPlansFoundErrorCode = 'plans-not-found-yet';

/**
 * this epic is used to refresh the table of plans for each of the children after
 * successfully creating a new plan for a specific child using the modal
 * this epic has been introduced to mainly deal with possible replica lag
 */
const fetchChildPlansOnPlanCreation = action$ =>
    action$.pipe(
        ofType(Actions.createPlanSuccess.type),
        switchMap(({payload}) => {
            return defer(() => fetchChildPlansObservable(payload.institutionId, payload.plan.childId)).pipe(
                mergeMap(planEntityFetchAllObservable => {
                    const fetchAllSuccessAction = planEntityFetchAllObservable.find(
                        action => action.type === PlansEntity.actions.fetchAll?.success.type,
                    );
                    // we check if the plan that we created was actually added and is correctly return
                    if (!hasValue(fetchAllSuccessAction) || fetchAllSuccessAction.payload.response.size === 0) {
                        throw Error(NoPlansFoundErrorCode);
                    }
                    return planEntityFetchAllObservable;
                }),
                // we keep retrying until we get a non-empty plan in the response
                retryWhen(errors => {
                    return errors.pipe(
                        filter(error => error.message === NoPlansFoundErrorCode),
                        delay(2000),
                    );
                }),
            );
        }),
    );
export default combineEpics(fetchChildPlansOnPlanCreation);
